"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EndPointsConfig_1 = require("./EndPointsConfig");
var RepCodeResponseMapper_1 = require("../models/mappers/RepCodeResponseMapper");
var AutoBillPayResponseMapper_1 = require("../models/mappers/AutoBillPayResponseMapper");
var PromoCodeResponseMapper_1 = require("../models/mappers/PromoCodeResponseMapper");
var BillCodeResponseMapper_1 = require("../models/mappers/BillCodeResponseMapper");
var FutureBillsResponseMapper_1 = require("../models/mappers/FutureBillsResponseMapper");
var Utils = require("../utils/UtilityFunctions");
var SaveCartResponseMapper_1 = require("../models/mappers/SaveCartResponseMapper");
var RetrieveCartResponseMapper_1 = require("../models/mappers/RetrieveCartResponseMapper");
var CartApi_1 = require("./CartApi");
var AddToCartMapper_1 = require("../models/mappers/AddToCartMapper");
var MonthlySavingsResponseMapper_1 = require("../models/mappers/MonthlySavingsResponseMapper");
var UserCurrentStateResponseMapper_1 = require("../models/mappers/UserCurrentStateResponseMapper");
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Api.prototype.saveCart = function (saveCartPostData) {
        return this.networker.post(EndPointsConfig_1.default.saveCartApiUrl, saveCartPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new SaveCartResponseMapper_1.SaveCartResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.applyPromoCode = function (promoCodePostData, isWireless) {
        var endPointForPromoCode = isWireless ?
            EndPointsConfig_1.default.promoCodeForWirelessAPI :
            EndPointsConfig_1.default.promoCodePOSTAPI;
        return this.networker.post(endPointForPromoCode, promoCodePostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PromoCodeResponseMapper_1.PromoCodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.applyRepCode = function (repCodePostData) {
        return this.networker.post(EndPointsConfig_1.default.repCodePOSTAPI, repCodePostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new RepCodeResponseMapper_1.RepCodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getCloserCoupon = function (closerKeyValue) {
        return __awaiter(this, void 0, void 0, function () {
            var closerEndpoint;
            return __generator(this, function (_a) {
                closerEndpoint = EndPointsConfig_1.default.closerCouponAPI;
                if (closerKeyValue) {
                    closerEndpoint += "?closerkey=" + closerKeyValue;
                }
                return [2 /*return*/, this.networker.get(closerEndpoint, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.getShareCartURL = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.shareCartAPI, {}, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.emptyAnyLOBCart = function (lobName) {
        var apiUrl = EndPointsConfig_1.default.emptyCartMSAPI;
        if (Utils.isCommonCartPresent()) {
            apiUrl = EndPointsConfig_1.default.emptyCommonCartMSAPI;
        }
        return this.networker.post(apiUrl + lobName, {}, {
            headers: Utils.getInitialHeaders(),
        }).catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.addToCart = function (postData) {
        var apiUrl = Utils.isOrchestrationAddToCart() ?
            EndPointsConfig_1.default.addToCartMSAPIOrchestration : EndPointsConfig_1.default.addToCartMSAPI;
        if (Utils.isCommonCartPresent()) {
            apiUrl = EndPointsConfig_1.default.addToCommonCartMSAPI;
        }
        return this.networker.post(apiUrl, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AddToCartMapper_1.AddToCartMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.autobillPay = function (enrollReq) {
        return this.networker.post(EndPointsConfig_1.default.autobillPayURL, enrollReq, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AutoBillPayResponseMapper_1.AutoBillPayResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.repriceCart = function (repriceCartReq) {
        return this.networker.post(EndPointsConfig_1.default.repriceCartUrl, repriceCartReq, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.validateZipCode = function (zipCode, updateCookie) {
        var postData = { zipCode: zipCode, updateCookie: updateCookie };
        return this.networker.post(EndPointsConfig_1.default.validateZip, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.validateZipCodeForBSSe = function (zipCode) {
        return this.networker.get(EndPointsConfig_1.default.validateZipForBsse + zipCode, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getLegalContent = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker
                        .get(url, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (response) {
                        return Promise.resolve(response);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.getInsuranceDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.get(EndPointsConfig_1.default.insuranceDetails, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (response) {
                        return Promise.resolve(response);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.retrieveCart = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.retrieveCartUrl, value, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(new RetrieveCartResponseMapper_1.RetrieveCartResponseMapper(data).getDataObject());
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.getSpoData = function (lineItem, mode, losg, subscriberNumber, customerId, zipCode) {
        var losgId = losg.id || '';
        var losgTypes = losg.losgType || '';
        var spoDataURL = "" + EndPointsConfig_1.default.spoMSAPI + lineItem.productCode + "?skuId=" + lineItem.productSKU + "&mode=" + mode;
        spoDataURL = spoDataURL + "&productTypes=" + lineItem.itemType + "&losgTypes=" + losgTypes + "&productKey=" + lineItem.productCode;
        if (Utils.isCommonCartPresent()) {
            var lobType = losg.productCategory;
            spoDataURL = EndPointsConfig_1.default.spoMSAPICommonCartMSAPI + "?lobs=" + lobType + "&losgTypes=" + losgTypes;
            spoDataURL = spoDataURL + "&productTypes=" + lineItem.itemType + "&selectedProductType=" + lineItem.itemType + "&productID=" + lineItem.productSKU;
            if (losgTypes === 'AL' && customerId) {
                var ctnInContextVal = (losg.wirelessLOSCharacteristics && losg.wirelessLOSCharacteristics.primaryPlanSubscriber) ?
                    losg.wirelessLOSCharacteristics.primaryPlanSubscriber : '';
                spoDataURL = spoDataURL + "&customerId=" + customerId + "&ctnInContext=" + ctnInContextVal;
            }
        }
        if (losgId && !Utils.isCommonCartPresent() && !Utils.IsNMDPRFlow()) {
            spoDataURL = spoDataURL + "&losgId=" + losgId;
        }
        if (losgId && Utils.IsNMDPRFlow()) {
            if (zipCode && !isNaN(Number(zipCode))) {
                spoDataURL = spoDataURL + "&losgId=" + losgId + "&expand=compatibleFeatures&zipCode=" + zipCode;
            }
            else {
                spoDataURL = spoDataURL + "&losgId=" + losgId + "&expand=compatibleFeatures";
            }
        }
        if (subscriberNumber) {
            spoDataURL = spoDataURL + "&subscriber=" + subscriberNumber;
        }
        if (Utils.enableHylatradeinComponent()) {
            spoDataURL = spoDataURL + "&offerTypes=tradein,standalone";
        }
        return this.networker.get(spoDataURL, {
            headers: Utils.getInitialHeaders(),
        }).then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getFutureBills = function () {
        var futureBillEtimatorUrl = EndPointsConfig_1.default.furtureBillsNewMSAPI;
        return this.networker.get(futureBillEtimatorUrl, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new FutureBillsResponseMapper_1.FutureBillsResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getMonthlySavings = function () {
        var apiUrl = EndPointsConfig_1.default.monthlySavingsAPI;
        if (Utils.isCommonCartPresent()) {
            apiUrl = EndPointsConfig_1.default.monthlySavingsCommonCartMSAPI;
        }
        return this.networker.get(apiUrl, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new MonthlySavingsResponseMapper_1.MonthlySavingsResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getUserCurrentState = function () {
        return this.networker.get(EndPointsConfig_1.default.getUserCurrentState, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new UserCurrentStateResponseMapper_1.UserCurrentStateResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getDeliveryDates = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.billCodeMSAPI, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new BillCodeResponseMapper_1.BillCodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.initialiseCart = function () {
        var initializeCartURL = EndPointsConfig_1.default.initializeCartAPI + "?source=cartui";
        return this.networker.get(initializeCartURL, {
            headers: Utils.getInitialHeaders(),
        }).then(function (data) {
            return Promise.resolve(data);
        }).catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.migrateCart = function () {
        return this.networker.post(EndPointsConfig_1.default.migrateCartAPI, {}, {
            headers: Utils.getInitialHeaders(),
        }).then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    // tslint:disable-next-line:no-any
    Api.prototype.postEdsEncriptionForActivation = function (req) {
        return this.networker.post(EndPointsConfig_1.default.edsEncryptionForActivation, req, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    // tslint:disable-next-line:no-any
    Api.prototype.cartInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.get(EndPointsConfig_1.default.cartInfoApi, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (response) {
                        return Promise.resolve(response);
                    }).catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    return Api;
}(CartApi_1.default));
exports.default = Api;
//# sourceMappingURL=Api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/Api.js
// module id = 31
// module chunks = 8